import Typography from "components/Typography";
import Grid from "components/primitives/Grid";
import type { GridProps } from "components/primitives/Grid";
import { memo } from "react";

interface PageTitleProps extends GridProps {
  children: React.ReactNode;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
}

/**
 * @description A component for displaying a page title with optional adornments.
 * By default, it uses a flex layout to align the title and adornments and occupies the full width of its container.
 */
function PageTitle(props: PageTitleProps) {
  const { children, startAdornment, endAdornment, sx, ...rest } = props;
  return (
    <Grid size="grow" sx={{ display: "flex", alignItems: "center", gap: 1, ...sx }} {...rest}>
      {startAdornment ? startAdornment : null}
      <Typography variant="TextXXL" component="h1" sx={{ fontWeight: 500 }}>
        {children}
      </Typography>
      {endAdornment ? endAdornment : null}
    </Grid>
  );
}

export default memo(PageTitle);
